import React, {useCallback, useContext, useEffect} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {LoaderClass} from "./LoaderClass"
import {MainPage} from "../pages/MainPage"
import {getAuthHeader, returnToPage} from "../functions"

export const ExitPage = () => {
    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)

    const fetch = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            await request(`${host}/api/user/logout`,
                'POST',
                {deviceId: auth.deviceId},
                {
                    Authorization: getAuthHeader(auth)
                })
            auth.logout()
            returnToPage('MainPage')
        } catch (e) {
            returnToPage('MainPage')
        }
    }, [request, auth])

    useEffect(() => {
        fetch().then()
    }, [fetch, auth])

    if (loading) {
        return <LoaderClass />
    }

    return (
        <>
            <MainPage />
        </>
    )
}